import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import system from './modules/system'
import settings from './modules/settings'
import admin from './modules/admin'
import auth from './modules/auth'
import users from './modules/users'
import roles from './modules/roles'
import home from './modules/home'
import notifications from './modules/notifications'
import companies from './modules/companies'
import userLogs from './modules/user-logs'
import parameters from './modules/parameters'
import tenants from './modules/tenants'
import leases from './modules/leases'
import accounts from './modules/accounts'
import collections from './modules/collections'
import properties from './modules/properties'
import reporting from './modules/reporting'
import contacts from './modules/contacts'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {    
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    ...system,
    ...home,
    ...admin,
    ...auth,
    ...settings,
    ...users,   
    ...notifications,
    ...roles,
    ...companies,    
    ...parameters,    
    ...userLogs,
    ...tenants,
    ...accounts,
    ...collections,
    ...properties,
    ...leases,
    ...reporting,
    ...contacts
  ]
})

/// ////////////////////
// Before Each Route //
/// ////////////////////
router.beforeEach(async (to, from, next) => {
 
  // load view layout
  store.commit('app/setLayout', to.meta.layout + '-layout')

  // check if vuex has auth else fetch from local (in case of page refresh)
  if (localStorage.getItem('token') != null && store.getters['user.token'] == null) {
    store.commit('user/setAuth')
  }

  // Auth Required Pages
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login'
      })
    } else {
      next()
    }

    // guest only pages
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'home'
      })
    }
    // pages for both guest and authorized users
  } else {
    next()
  }
})


///////// Catch duplicates and reload
// function patchRouterMethod (router, methodName)
// {
//     router['old' + methodName] = router[methodName]
//     router[methodName] = async function (location)
//     {
//         return router['old' + methodName](location).catch((error) =>
//         {
//             if (error.name === 'NavigationDuplicated')
//             {
//                return this.currentRoute           
//             }
//             throw error
//         })
//     }
// }

// patchRouterMethod(router, 'push')
// patchRouterMethod(router, 'replace')

export default router
